/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_A13Inputs */

const et_faq_a13 = /** @type {(inputs: Faq_A13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kõige levinumad vead on ebaselge pakkumine, aeglane laadimiskiirus, nõrk CTA, puuduv sotsiaalne tõestus, liiga keeruline kontaktivorm ja SEO-struktuuri puudumine. Kui klient ei saa mõne sekundiga aru, mida sa pakud ja miks sind usaldada, lahkub ta konkurendi juurde. ScalingWebs parandab need probleemid süsteemselt. Me vaatame veebilehte mitte ainult disaini, vaid müügi, SEO, kasutajakogemuse ja andmete põhjal.`)
};

const en_faq_a13 = /** @type {(inputs: Faq_A13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The most common mistakes are an unclear offer, slow page speed, weak CTA, missing social proof, overly complex contact forms, and no SEO structure. If a visitor can't understand what you offer and why to trust you within a few seconds, they leave for a competitor. ScalingWebs fixes these issues systematically. We evaluate websites not only through design, but through sales, SEO, user experience, and data.`)
};

/**
* | output |
* | --- |
* | "The most common mistakes are an unclear offer, slow page speed, weak CTA, missing social proof, overly complex contact forms, and no SEO structure. If a visi..." |
*
* @param {Faq_A13Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_a13 = /** @type {((inputs?: Faq_A13Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_A13Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_a13(inputs)
	return en_faq_a13(inputs)
});